import { axios } from '@/utils/request'

const scope = 'server'

export const loginByUsername = (username, password, code, randomStr) => {
  const grant_type = 'password'
  return axios({
    url: '/oauth/token',
    method: 'post',
    headers: {
      'Authorization': 'Basic bWFzdGVyOnl4Z21hc3Rlcg=='
    },
    params: { username, password, grant_type, code, randomStr, scope }
  })
}

export const refreshToken = (refresh_token) => {
  const grant_type = 'refresh_token'
  return axios({
    url: '/oauth/token',
    headers: {
      'Authorization': 'Basic bWFzdGVyOnl4Z21hc3Rlcg=='
    },
    method: 'post',
    params: { refresh_token, grant_type, scope }
  })
}

export const getInfo = () => {
  return axios({
    url: '/studentManage/info',
    method: 'get'
  })
}

export const logout = () => {
  return axios({
    url: '/oauth/removeToken',
    method: 'post'
  })
}
